
import { Vue, Component } from "vue-property-decorator";

@Component
export default class DisposeBeforeDestroyComponent extends Vue {

  disposables: Array<() => void> = [];

  beforeDestroy() {
    this.disposables.forEach((disposable) => disposable());
  }
}
